export var DocsBlockContainerSize;
(function (DocsBlockContainerSize) {
    /** Default. Image is centered within a container */
    DocsBlockContainerSize["centered"] = "Centered";
    /** The container has the height of the asset within */
    DocsBlockContainerSize["naturalHeight"] = "NaturalHeight";
})(DocsBlockContainerSize || (DocsBlockContainerSize = {}));
